import {Headers, RequestOptions, ResponseContentType} from '@angular/http';
/**
 * Created by swifta on 1/19/18.
 */


export class Constants {

  public static readonly VENDOR = 'TIG';

  public static readonly VENDOR_PREFIX = 'TIG_';
  public static readonly VERSION = '1.2.0-1';

  // Dev / Test
 //  public static readonly SERVICE_URL = 'https://137.74.50.58/tig/api';

  // UAT service url
 // public static readonly SERVICE_URL = 'https://test.mfisa.com/tig/api';

  // Master service url
  public static readonly SERVICE_URL = 'https://vtu.tiglimited.net/tig/api';






  public static readonly LOGIN_URL = Constants.SERVICE_URL + '/login';
  public static readonly PROFILE_URL = Constants.SERVICE_URL + '/admins/profile';

  public static readonly CREATE_ADMIN_URL = Constants.SERVICE_URL + '/admins/create';
  static UPDATE_ADMIN_URL = Constants.SERVICE_URL + '/admins/update/';

  public static readonly PROFILE =  Constants.VENDOR_PREFIX + 'profile';
  public static readonly ACCESS_TOKEN = Constants.VENDOR_PREFIX + 'access_token';
  public static readonly REFRESH_TOKEN = Constants.VENDOR_PREFIX + 'refresh_token';
  public static TOKEN =  Constants.VENDOR_PREFIX + 'token';

  static ADMIN_DASHBOARD: any = '/admin/dashboard';
  static GET_ROLES_URL: string = Constants.SERVICE_URL + '/roles/';
  static EMPTY = '';
  static SIGNIN_URL: any = '/sign-in';
  static COUNTRY_URL: string = Constants.SERVICE_URL + '/countries';
  static USER_CREATED_SUCCESSFULLY: any = 'User created successfully';
  static USER_UPDATED_SUCCESSFULLY: any = 'Update successful';
  static RESET_PASSWORD_URL: string = Constants.SERVICE_URL + '/password/reset';
  static MAIL_SENT = '/mail-sent';
  static CREATE_PASSWORD_URL: string = Constants.SERVICE_URL + '/password/create';
  static CREATE_ROLES_URL: string = Constants.SERVICE_URL + '/roles/create';
  static GET_PERMISSIONS_URL = Constants.SERVICE_URL + '/permissions/';
  static USER_PERMISSIONS_URL = Constants.SERVICE_URL + '/users/permission/';
  static UPDATE_ROLES_URL = Constants.SERVICE_URL + '/roles/update/';
  static DELETE_ROLES_URL = Constants.SERVICE_URL + '/roles/delete/';
  static CREATE_AGENT_URL: string = Constants.SERVICE_URL + '/agents/create?';
  static AGENT_URL: string = Constants.SERVICE_URL + '/agents/';
  static ADMIN_URL: string = Constants.SERVICE_URL + '/admins/';
  static USERS_URL: string = Constants.SERVICE_URL + '/users/';
  static ACTIVATION_URL: string = Constants.SERVICE_URL + '/admins/activation-mail/';
  static USERS_NETWORK_URL: string = Constants.SERVICE_URL + '/networks/user-network-config/';
  static USERS_NETWORK_CONFIG: string = Constants.SERVICE_URL + '/networks/new-agent-config/';
  static NETWORKS_URL: string = Constants.SERVICE_URL + '/networks/';
  static USERS_TRANSACTIONS_URL = Constants.SERVICE_URL + '/reports/transactions/';
  static CUSTOMER_URL: string = Constants.SERVICE_URL + '/customers/';
  static GUEST_URL: string = Constants.SERVICE_URL + '/guest/';
  static NETWORK_URL: string = Constants.SERVICE_URL + '/networks/';
  static BLOCK = '/block';
  static UNBLOCK = '/unblock';
  static DELETE = '/delete';
  static FREEZE_ACCOUNT_URL: string = Constants.SERVICE_URL + '/agents/account/freeze';
  static ADMIN_UPDATE_URL: string = Constants.SERVICE_URL + '/admins/update/';
  static MANAGE_FUND_REQUEST_URL = Constants.SERVICE_URL + '/wallet/fund-request';
  static FUND_REQUESTS_HISTORY = Constants.SERVICE_URL + '/wallet/fund-requests';
  static FUND_REQUESTS_RANGE = Constants.SERVICE_URL + '/wallet/fund-requests-range';
  static FUND_AGENT = Constants.SERVICE_URL + '/wallet/fund';
  static FREEZE_ACCOUNT = Constants.AGENT_URL + '/account/freeze';
  static ADMIN_STATISTICS_URL: string = Constants.SERVICE_URL + '/reports/dashboard/user-statistic';
  static DATA_STATISTICS_URL: string = Constants.SERVICE_URL + '/reports/dashboard/data-report-statistics';
  static CHART_REPORT_STATISTICS_URL: string = Constants.SERVICE_URL + '/reports/dashboard/report-statistics';
  static ADMIN_WALLET_URL: string = Constants.SERVICE_URL + '/reports/wallet-transactions';
  static AIRTIME_TRANSACTIONS: string = Constants.SERVICE_URL + '/reports/transactions';
  static DATA_TRANSACTIONS: string = Constants.SERVICE_URL + '/reports/data-transactions';
  static TRANSACTIONS : string = Constants.SERVICE_URL + '/transactions';
  static FUND_REQUESTS: string = Constants.SERVICE_URL + '/wallet/fund-requests';
  static WALLET_TRANSACTIONS: string = Constants.SERVICE_URL + '/reports/wallet-transactions';
  static CHANGE_PASSWORD_URL: string = Constants.SERVICE_URL + '/password/change';
  static UPLOAD_USER_DATA_URL: string = Constants.SERVICE_URL + '/agents/upload/agent';
  static TOKEN_EXPIRED_ERROR: string = 'TK_400';
  static SEARCH_USER_URL = Constants.SERVICE_URL + '/users/search/';
  static REFRESH_TOKEN_URL: string = Constants.SERVICE_URL + '/refreshToken';


  // platform permissions
  static CAN_DO_ALL = 'ALL';

  static CAN_CREATE_ADMIN = 'CREATE_ADMIN';
  static CAN_DELETE_ADMIN = 'DELETE_ADMIN';
  static CAN_VIEW_ADMIN = 'VIEW_ADMIN';
  static CAN_UPDATE_ADMIN = 'UPDATE_ADMIN';
  static CAN_BLOCK_ADMIN = 'BLOCK_ADMIN';
  static CAN_UNBLOCK_ADMIN = 'UNBLOCK_ADMIN';

  static CAN_CREATE_AGENT = 'CREATE_AGENT';
  static CAN_DELETE_AGENT = 'DELETE_AGENT';
  static CAN_VIEW_AGENT = 'VIEW_AGENT';
  static CAN_UPDATE_AGENT = 'UPDATE_AGENT';
  static CAN_FUND_AGENT = 'FUND_AGENT';
  static CAN_FUND_WALLET = 'FUND_WALLET';
  static CAN_BLOCK_AGENT = 'BLOCK_AGENT';
  static CAN_UNBLOCK_AGENT = 'UNBLOCK_AGENT';

  static CAN_BLOCK_CUSTOMER = 'BLOCK_CUSTOMER';
  static CAN_UNBLOCK_CUSTOMER = 'UNBLOCK_CUSTOMER';
  static CAN_VIEW_TRANSACTIONS = 'VIEW_TRANSACTIONS';

  static CAN_CREATE_ROLE = 'CREATE_ROLE';
  static CAN_DELETE_ROLE = 'DELETE_ROLE';
  static CAN_VIEW_ROLE = 'VIEW_ROLE';
  static CAN_UPDATE_ROLE = 'UPDATE_ROLE';

  static CAN_VIEW_SYSTEM_REPORT = 'VIEW_SYSTEM_REPORT';
  static CAN_SYSTEM_SETTINGS= 'SYSTEM_SETTINGS';

// set default request header
  static getRequestDefaultHeader(token: any): Headers {
    if(token === null){
      window.location.href = '/';
    }
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Authorization', token);
    return headers;
  }

// set refresh token header
  static getRefreshTokenRequestDefaultHeader(token: any): Headers {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Refresh-Token', token);
    return headers;
  }
  /**
   * get Request Header
   * @returns {RequestOptions}
   */
  static getRequestHeader(): RequestOptions {
    return new RequestOptions({headers: Constants.getRequestDefaultHeader('')})
  }

  static getMultipartRequestHeader(token: any): Headers {
    const headers = new Headers();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Authorization', token);
    return headers;
  }

  static getRequestOption(token: any): RequestOptions {
    return new RequestOptions({headers: Constants.getRequestDefaultHeader(token)});
  }

  static getFileRequestOption(token: any): RequestOptions {
    return new RequestOptions({headers: Constants.getRequestDefaultHeader(token), responseType: ResponseContentType.Blob});
  }

  static getRefreshTokenRequestOption(token: any): RequestOptions {
    return new RequestOptions({headers: Constants.getRefreshTokenRequestDefaultHeader(token)});
  }

  static getMultipartRequestOption(token: any): RequestOptions {
    return new RequestOptions({headers: Constants.getMultipartRequestHeader(token)});
  }

}



// WEBPACK FOOTER //
// ./src/app/util/Constants.ts